import {
  createContext,
  useContext,
  useState,
  useMemo,
  type ReactNode,
} from 'react';

interface GlobalLoadingContextProps {
  globalLoading: boolean;
  setGlobalLoading: (loading: boolean) => void;
}

const GlobalLoadingContext = createContext<GlobalLoadingContextProps>({
  globalLoading: false,
  setGlobalLoading: () => {},
});

export const GlobalLoadingProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [globalLoading, setGlobalLoading] = useState(false);

  const value = useMemo(
    () => ({ globalLoading, setGlobalLoading }),
    [globalLoading]
  );

  return (
    <GlobalLoadingContext.Provider value={value}>
      {children}
    </GlobalLoadingContext.Provider>
  );
};

export const useGlobalLoading = () => {
  const context = useContext(GlobalLoadingContext);
  if (!context) {
    throw new Error(
      'useGlobalLoading must be used within a GlobalLoadingProvider'
    );
  }
  return context;
};
